export default {
    serverURI: 'https://www.intranet-gruponalvarte.com/api/',
    //serverURI: 'https://23.236.63.235/api/',
}
  
